import devicesStyle from "../devices.module.css";

import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DevicesOverviewContainer = ({ deviceOverview, setDeviceTypeFilter }) => {
  const { t } = useTranslation();

  const handleDeviceTypeClick = (deviceType) => {
    setDeviceTypeFilter(deviceType);
  };

  return (
    <Container className={devicesStyle["devices-overview-container"]}>
      <Row>
        <Col className={devicesStyle["devices-status-container"]}>
          <div className={devicesStyle["sub-status-container"]}>
            <div className={devicesStyle["number-container"]}>
              <div className={devicesStyle["number-title"]}>
                {t("dc258b7538")}
              </div>
              <a
                href="#/"
                className={devicesStyle["number-count"]}
                onClick={() =>
                  handleDeviceTypeClick({
                    productCategory: "All",
                    title: "b1c94ca2fb",
                  })
                }
              >
                {deviceOverview ? deviceOverview.deviceCount.total : 0}
              </a>
            </div>
          </div>

          <div className={devicesStyle["sub-status-container"]}>
            <div>
              <img
                className="mx-3"
                src="../img/v2/icon/device_ap.png"
                alt=""
                width={65}
              />
            </div>
            <div className={devicesStyle["number-container"]}>
              <div className={devicesStyle["number-title"]}>
                {t("49757fe172")}
              </div>
              <a
                href="#/"
                className={devicesStyle["number-count"]}
                onClick={() =>
                  handleDeviceTypeClick({
                    productCategory: "ap",
                    title: "cb3f9a1103",
                  })
                }
              >
                {deviceOverview ? deviceOverview.deviceCount.ap : 0}
              </a>
            </div>
          </div>

          <div className={devicesStyle["sub-status-container"]}>
            <div>
              <img
                className="mx-3"
                src="../img/v2/icon/device_switch.png"
                alt=""
                width={65}
              />
            </div>
            <div className={devicesStyle["number-container"]}>
              <div className={devicesStyle["number-title"]}>
                {t("0052efad5d")}
              </div>
              <a
                href="#/"
                className={devicesStyle["number-count"]}
                onClick={() =>
                  handleDeviceTypeClick({
                    productCategory: "switch",
                    title: "bbc155fb2b",
                  })
                }
              >
                {deviceOverview ? deviceOverview.deviceCount.switch : 0}
              </a>
            </div>
          </div>

          <div className={devicesStyle["sub-status-container"]}>
            <div>
              <img
                className="mx-3"
                src="../img/v2/icon/device_gateway.png"
                alt=""
                width={65}
              />
            </div>
            <div className={devicesStyle["number-container"]}>
              <div className={devicesStyle["number-title"]}>
                {t("a0ea006dc2")}
              </div>
              <a
                href="#/"
                className={devicesStyle["number-count"]}
                onClick={() =>
                  handleDeviceTypeClick({
                    productCategory: "gateway",
                    title: "926dec9494",
                  })
                }
              >
                {deviceOverview ? deviceOverview.deviceCount.gateway : 0}
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DevicesOverviewContainer;
